import React from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaInstagram, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-zinc-900 text-white py-12 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-5 gap-8">
        {/* İletişim */}
        <div className="space-y-4">
          <h4 className="text-lg font-semibold border-b border-white w-fit pb-1">İLETİŞİM</h4>
          <p className="flex items-start gap-2">
            <FaMapMarkerAlt className="mt-1" />
            Merkez Gökçebelen Köyü Mersin
          </p>
          <p className="flex items-center gap-2">
            <FaPhone />
            0.324. 473 25 34–36
          </p>
          <p className="flex items-center gap-2">
            <FaEnvelope />
            info@guneygelisim.k12.tr
          </p>

          <div>
            <h4 className="text-lg font-semibold border-b border-white w-fit pb-1 mt-6">Sosyal Medya</h4>
            <div className="flex items-center gap-4 mt-2">
              <a
                href="https://www.instagram.com/gelisimkoleji"
                target="_blank"
                rel="noopener noreferrer"
                className="text-2xl hover:text-[#a03838] transition"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.youtube.com/@gelisimkoleji"
                target="_blank"
                rel="noopener noreferrer"
                className="text-2xl hover:text-[#a03838] transition"
              >
                <FaYoutube />
              </a>
            </div>
          </div>
        </div>

        {/* Google Harita */}
        <div className="w-full max-w-sm md:max-w-md lg:max-w-full mx-auto">
          <img
            src="/images2/map.jpg"
            alt="Harita"
            className="w-full h-auto object-cover rounded-lg"
          />
        </div>

        {/* Diğer Linkler */}
        <div>
          <h4 className="text-lg font-semibold border-b border-white w-fit pb-1">BÖLÜMLERİMİZ</h4>
          <ul className="mt-2 space-y-1 text-sm">
            <li>&rsaquo; Anaokulu</li>
            <li>&rsaquo; İlkokul</li>
            <li>&rsaquo; Ortaokul</li>
            <li>&rsaquo; Lise</li>
          </ul>
        </div>

        <div>
          <h4 className="text-lg font-semibold border-b border-white w-fit pb-1">KURUMSAL</h4>
          <ul className="mt-2 space-y-1 text-sm">
            <li>&rsaquo; Hakkımızda</li>
            <li>&rsaquo; Yönetim</li>
            <li>&rsaquo; Hedef ve İlkelerimiz</li>
            <li>&rsaquo; Bülten ve Yayınlarımız</li>
          </ul>
        </div>

        <div>
          <h4 className="text-lg font-semibold border-b border-white w-fit pb-1">ETKİNLİKLER</h4>
          <ul className="mt-2 space-y-1 text-sm">
            <li>&rsaquo; Anaokulu</li>
            <li>&rsaquo; İlkokul</li>
            <li>&rsaquo; Ortaokul</li>
            <li>&rsaquo; Lise</li>
          </ul>
        </div>
      </div>

      {/* Alt Satır */}
      <div className="text-center text-sm text-gray-400 mt-12 border-t border-gray-700 pt-4">
        © 2025 Güney Gelişim Okulları
      </div>
    </footer>
  );
};

export default Footer;
